import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WmsDialogComponent, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsMessageComponent, BaseComponent } from '@wms/components';
import { CommonModule } from '@angular/common';
import { BaseVariablePropertyFactoryService, VARIABLE_CONSTANTS, WebserviceVariableCreation, OpenapiVariableCreation, VariableCrudManagerService, DatabaseVariableCreation, DeviceVarCreationComponent } from '@wms/variables';
import { forEach } from 'lodash-es';
import { isDefined, runtimeEventManager } from '@wm/core';
import { BaseVariableService, VariablesTemplateComponent, DatabaseVarCreationComponent, NavigationActionCreationComponent, NotificationActionCreationComponent, SecurityserviceVarCreationComponent, VariableTabViewComponent, WebserviceVarCreationComponent, JavaserviceVarCreationComponent, ImportedApiVarCreationComponent, DatabaseApiVarCreationComponent } from '@wms/variables';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FormsModule } from '@angular/forms';
import { ServiceFactoryService, DataModelDesignManagerService, ProjectService, PageService } from "@wms/services";
import { PageWsService } from '@wms/workspace';

@Component({
  standalone: true,
  selector: 'wms-add-variable-config',
  templateUrl: './add-variable-config.component.html',
  styleUrls: ['./add-variable-config.component.less'],
  imports: [
    FormsModule,
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WebserviceVarCreationComponent,
    DatabaseVarCreationComponent,
    ImportedApiVarCreationComponent,
    VariablesTemplateComponent,
    DatabaseApiVarCreationComponent,
    SecurityserviceVarCreationComponent,
    NavigationActionCreationComponent,
    NotificationActionCreationComponent,
    VariableTabViewComponent,
    JavaserviceVarCreationComponent,
    DeviceVarCreationComponent,
    WmsMessageComponent,
    TooltipModule]
})
export class AddVariableConfigComponent extends BaseComponent implements OnInit {
  @Output() onModalClose: EventEmitter<any> = new EventEmitter<any>();
  @Input() serviceTypeGroups: any;
  @Input() disableBinding: boolean = false;

  hoveredServiceType: any;
  serviceSelectionHeading = 'LABEL_SELECT_VARIABLE_SERVICE';
  stepCount = 1;
  selectedServiceType: any;
  variableCreationServices: any = new Map();
  selectedVarService: any;


  constructor(private variablePropertyFactory: BaseVariablePropertyFactoryService, private serviceFactory: ServiceFactoryService,
    public varManagerService: VariableCrudManagerService, public baseVariableService: BaseVariableService,
    private pageService: PageService, private dataModelDesignManagerService: DataModelDesignManagerService, public pageWsService: PageWsService) {
    super();
    this.variableCreationServices.set('databaseapi', new DatabaseVariableCreation(serviceFactory, varManagerService, baseVariableService, dataModelDesignManagerService, this.projectService));
    this.variableCreationServices.set('openapi', new OpenapiVariableCreation(serviceFactory, varManagerService, baseVariableService));
    this.variableCreationServices.set('web', new WebserviceVariableCreation(serviceFactory, varManagerService));
    this.varManagerService.addVariableDialogMsg = null;
  }

  ngOnInit(): void {
    this.baseVariableService.initHeaderOptions(this.baseVariableService.currentVariableView);
  }

  handleModelChange(changeObj: any) {
    this.baseVariableService.selectedVariable.propertyObj[changeObj.propertyName].modelObj[this.baseVariableService.selectedVariable.propertyObj[changeObj.propertyName].modelKey] = changeObj.$event;
    if ((this.selectedVarService && this.selectedVarService.name !== this.baseVariableService.selectedVariable.variableObject.name) || !this.selectedVarService) {
      let owner: any = this.baseVariableService.selectedVariable.variableObject.owner === 'Page' ? this.pageService.activePageName : 'App';
      this.selectedVarService = this.baseVariableService.variableInstanceCollection[owner][this.baseVariableService.selectedVariable.variableObject.name]
    }
    this.selectedVarService?.__onPropertyChange(changeObj.propertyName, changeObj.$event);
  }

  /**
   * On Back button press we will be redirected to the page where we select the type of variable
   */
  back() {
    this.varManagerService.showPrimaryProps = false;
    this.stepCount -= 1;
    if (this.stepCount == 1) {
      this.baseVariableService.selectedVariable = undefined;
      this.varManagerService.selectedVariableCategory = undefined;
    }
    this.baseVariableService.createOnly = false;
    this.varManagerService.addVariableDialogMsg = null;
  }

  closeModal() {
    this.varManagerService.showPrimaryProps = false;
    this.baseVariableService.createOnly = false;
    if (this.baseVariableService.prevSelectedVariable) {
      if (this.baseVariableService.selectedEvt) {
        const selectedEvtExp = this.baseVariableService.prevSelectedVariable.variableObject[this.baseVariableService.selectedEvt]?.split(';');
        const index = selectedEvtExp?.includes("New Action") ? selectedEvtExp?.indexOf("New Action") : selectedEvtExp?.indexOf("New Variable");
        selectedEvtExp?.splice(index,1);
        const orgExp = selectedEvtExp?.join(';');
        this.baseVariableService.prevSelectedVariable.variableObject[this.baseVariableService.selectedEvt] = orgExp;
        this.varManagerService.currentSelectedTabView = 'events';
      }
      this.baseVariableService.selectedVariable = this.baseVariableService.prevSelectedVariable;
      this.varManagerService.currentSelectedTabView = '';
      this.varManagerService.getTypesOfSelectedVariables(this.baseVariableService.selectedVariable.category, this.baseVariableService.selectedVariable.variableObject, false,  undefined, false);
    }
    this.baseVariableService.onEventOptionsChangeSubject.next(null);
    this.onModalClose.emit();
  }

  onServiceSelection(serviceType: any) {
    this.selectedServiceType = serviceType;
    this.onNextClick();
  };

  onNextClick() {
    let categories, options: any,
      serviceType = this.selectedServiceType;
    this.stepCount += 1;
    this.baseVariableService.createOnly = true;
    this.baseVariableService.initHeaderOptions(this.baseVariableService.currentVariableView);
    if (this.stepCount === 2) {
      this.varManagerService.showPrimaryProps = true;
      categories = this.variablePropertyFactory.getCategoriesByServiceType(serviceType);
      if (categories.length === 1 && this.selectedServiceType !== VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.DATABASE_API && this.selectedServiceType !== VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.OPENAPI) {
        options = {
          'owner': 'Page',
          '_serviceType': (VARIABLE_CONSTANTS.VARIABLE_TO_SERVICE_TYPE_MAP as any)[serviceType] || serviceType
        };
        if (serviceType == VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.SECURITY) {
          options.service = 'securityService';
        }
        this.varManagerService.selectedVariableCategory = categories[0];
        this.varManagerService.createVariable(this.varManagerService.selectedVariableCategory, options);
      } else {
        this.varManagerService.selectedVariableCategory = categories[0];
        // Handle interim service selection here
        this.varManagerService.initVariableObj = {
          propertyObj: this.variablePropertyFactory.getPropertiesByServiceType(this.selectedServiceType),
          values: {}
        };
        forEach(this.varManagerService.initVariableObj.propertyObj, (property, name) => {
          property.modelObj = this.varManagerService.initVariableObj.values;
          property.modelKey = name;
          if (isDefined(property.value)) {
            property.modelObj[property.modelKey] = property.value;
          }
        });
        this.variableCreationServices.get(this.selectedServiceType).getVariableDependencies();
      }
      this.selectedVarService = this.baseVariableService.variableInstanceCollection[this.pageService.activePageName][this.baseVariableService.selectedVariable?.variableObject.name];
      this.selectedVarService?.__getVariableDependencies();
    }
  };

  override ngOnDestroy(): void {
    this.baseVariableService.disableDialogActions = false;
    if (this.baseVariableService.isVariableDialog) {
      this.baseVariableService.initServiceTypesList('data');
      this.baseVariableService.isVariableDialog = false;
    }
  }

}
